import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | KEYMAP_LABEL] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | KEYMAP_LABEL] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | KEYMAP_LABEL] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | KEYMAP_LABEL] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | KEYMAP_LABEL] Add Entity',
  UpdateEntity = '[STORE | ENTITY | KEYMAP_LABEL] Update Entity',
  RemoveEntity = '[STORE | ENTITY | KEYMAP_LABEL] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | KEYMAP_LABEL] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | KEYMAP_LABEL] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | KEYMAP_LABEL] Clean Up Snapshots',
  RearrangeKeymapLabels = '[STORE | ENTITY | KEYMAP_LABEL] Rearrange Keymap Labels',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.KeymapLabelEntityModels.KeymapLabel> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.KeymapLabelEntityModels.KeymapLabel> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.KeymapLabelEntityModels.KeymapLabel> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Rearrange Keymap Labels
 */
export class RearrangeKeymapLabels {
  public static readonly type = ActionTypes.RearrangeKeymapLabels;
  
  public constructor(public keymapLabels: FlatModels.KeymapLabelEntityModels.KeymapLabel[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>